import { GetDigest } from '@front-app/api-generated/digests-api';
import { SetRequired, Merge } from 'type-fest';

export type ApiDigestResponse = SetRequired<GetDigest, 'id' | 'groupId' >;
export type FullDigest = Merge<SetRequired<GetDigest, 'id' | 'groupId' >, DigestWithLogicalTiming>;

interface DigestWithLogicalTiming {
	timingMonthly: DigestMonthlyTiming;
}

export interface DigestMonthlyTiming {
	firstWeek: Set<DigestTimingDay>;
	secondWeek: Set<DigestTimingDay>;
	thirdWeek: Set<DigestTimingDay>;
	fourthWeek: Set<DigestTimingDay>;
	lastWeek: Set<DigestTimingDay>;
}

export type MonthlyTimingKey = keyof DigestMonthlyTiming;

export enum DigestTimingDay {
	SUNDAY = 'sunday',
	MONDAY = 'monday',
	TUESDAY = 'tuesday',
	WEDNESDAY = 'wednesday',
	THURSDAY = 'thursday',
	FRIDAY = 'friday',
	SATURDAY = 'saturday',
}
